import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";
import { RoleClaimApiType } from "./types/apiTypes";

const roleClaimApi: RoleClaimApiType = {
  getLookups: () => apiClient.get(endPoints.roleClaim.getLookups()),
  get: (roleId) => apiClient.get(endPoints.roleClaim.get(roleId)),
  save: (payload) => apiClient.post(endPoints.roleClaim.save(), payload),
};

export default roleClaimApi;
